import { ref } from 'vue'

import { defineStore } from 'pinia'

export interface RegisterInfo {
  emailAddress: string
  invitationCode: string
  newPassword: string
  confirmNewPassword: string
  userName: string
  phone: string
  correlationId: string
  verificationCode: string
  photoBase64?: string
  invitationEmail: string
  invitationChecksum: string
}

export const useRegisterStore = defineStore('register', () => {
  const $reset = () => {
    resetRegisterInfo()
  }

  const registerInfo = ref<RegisterInfo>({
    emailAddress: '',
    invitationCode: '',
    newPassword: '',
    confirmNewPassword: '',
    userName: '',
    phone: '',
    correlationId: '',
    verificationCode: '',
    photoBase64: '',
    invitationEmail: '',
    invitationChecksum: ''
  })

  const resetRegisterInfo = () => {
    registerInfo.value = {
      emailAddress: '',
      invitationCode: '',
      newPassword: '',
      confirmNewPassword: '',
      userName: '',
      phone: '',
      correlationId: '',
      verificationCode: '',
      photoBase64: '',
      invitationEmail: '',
      invitationChecksum: ''
    }
  }

  return {
    $reset,
    registerInfo,
    resetRegisterInfo
  }
})
